import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from './navbar';
import { FaTrophy, FaChevronLeft, FaUsers, FaCoins, FaCalendarAlt } from 'react-icons/fa';
import './matchbytag.css';

const MatchesByTag = () => {
  const { tag } = useParams();
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        const res = await axios.get(`https://backend.aubattle.com/api/matches/tag/${tag}`);
        const upcomingMatches = res.data.filter(match => match.status !== 'completed');
        setMatches(upcomingMatches);
      } catch (error) {
        console.error("Error fetching matches:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchMatches();
  }, [tag]);




  return (
    <div className="gaming-matches-container">
      <Navbar/>
      <div className="gaming-matches-header">
        <button className="gaming-back-btn" onClick={() => navigate(-1)}>
          <FaChevronLeft className="icon" /> Back to Dashboard
        </button>
        <h1 className="gaming-title">{tag.toUpperCase()} TOURNAMENTS</h1>
        <p className="gaming-subtitle">Compete in the hottest {tag} battles</p>
      </div>

      {loading ? (
        <div className="gaming-loading">
          <div className="gaming-spinner"></div>
          <p>Loading tournaments...</p>
        </div>
      ) : matches.length === 0 ? (
        <div className="gaming-empty-state">
          <p>No upcoming {tag} tournaments found</p>
          
        </div>
      ) : (
        <div className="gaming-matches-grid">
          {matches.map((match) => (
            <div key={match.id} className="gaming-match-card">
              <div className="gaming-card-header">
                <div className="gaming-prize-pool">
                  <FaTrophy className="gaming-icon" />
                  <span>{match.prize} Rs Prize Pool</span>
                </div>
                <h3 className="gaming-match-title">{match.title}</h3>
                <div className="gaming-match-time">
                  <FaCalendarAlt className="gaming-icon" />
                  <span>Started At {match.text_time}</span>
                </div>
              </div>

              <div className="gaming-card-body">
                <div className="gaming-match-detail">
                  <FaCoins className="gaming-icon" />
                  <span>Entry: {match.entry_fee} Rs</span>
                </div>
                <div className="gaming-match-detail">
                  <FaUsers className="gaming-icon" />
                  <span>Slots: {match.current_players}/{match.max_players}</span>
                </div>
              </div>

              <div className="gaming-card-footer">
                <button
                  className="gaming-join-btn"
                  onClick={() => navigate(`/match/${match.id}/slots`)}
                >
                  JOIN TOURNAMENT
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MatchesByTag;